import './InvoiceOptionTabs.scss';
import React, {useEffect, useState} from "react";
import {InvoiceOptionTab} from "./InvoiceOptionTab/InvoiceOptionTab";
import {InvoiceOption} from "../../models/item.model";

interface InvoiceOptionTabsProps {
    options: InvoiceOption[];
    activeOption: InvoiceOption | null;
    onSelectOption: (option: InvoiceOption) => void;
    onSelectTab: (option: InvoiceOption) => void;
}

export const InvoiceOptionTabs: React.FunctionComponent<InvoiceOptionTabsProps> = ({activeOption, options, ...props}) => {

    return (
        <section className="invoice-option-tabs">
            {
                options.map((option) => {
                    return (<InvoiceOptionTab key={option.id} title={option.tab_title}
                                              total={option.total}
                                              isSelectedTab={option.id === activeOption?.id}
                                              isSelectedOption={option.is_selected}
                                              onSelectTab={() => {
                                                  props.onSelectTab(option);
                                              }}
                                              onSelectOption={() => props.onSelectOption(option)}/>)
                })
            }
        </section>
    );
};